<template>
  <div>
    <h2>Historial de medidas</h2>
    <v-data-table
      :headers="headers"
      :items="historial"
      class="mb-4"
      :items-per-page="5"
      :footer-props="{itemsPerPageText: 'Por página'}"
    >
      <template v-slot:item.fechaMedida="{ item }">
        {{ item.fechaMedida | fecha }}
      </template>
    </v-data-table>

    <h3>Agregar nuevas medidas</h3>
    <v-form ref="form" v-model="formValido">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.peso" label="Peso (kg)" type="number" step="0.01" required></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.altura" label="Altura (m)" type="number" step="0.01" required></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaPecho" label="Pecho (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaCintura" label="Cintura (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaTriceps" label="Tríceps (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaBiceps" label="Bíceps (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaGluteos" label="Glúteos (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaCuadriceps" label="Cuádriceps (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaPantorrilla" label="Pantorrilla (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="nuevaMedida.medidaEspalda" label="Espalda (cm)" type="number" step="0.01"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-menu v-model="menuFecha" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="nuevaMedida.fechaMedida" label="Fecha de la medida" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="nuevaMedida.fechaMedida" @input="menuFecha = false" locale="es"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-btn color="primary" @click="agregarMedida">Agregar</v-btn>
    </v-form>
    <v-snackbar v-model="mensaje.visible" :color="mensaje.color" :timeout="3000">{{ mensaje.texto }}</v-snackbar>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'

export default {
  name: 'HistorialMedidas',
  props: ['idMiembro'],
  data() {
    return {
      historial: [],
      headers: [
        { text: 'Fecha', value: 'fechaMedida' },
        { text: 'Peso', value: 'peso' },
        { text: 'Altura', value: 'altura' },
        { text: 'Pecho', value: 'medidaPecho' },
        { text: 'Cintura', value: 'medidaCintura' },
        { text: 'Tríceps', value: 'medidaTriceps' },
        { text: 'Bíceps', value: 'medidaBiceps' },
        { text: 'Glúteos', value: 'medidaGluteos' },
        { text: 'Cuádriceps', value: 'medidaCuadriceps' },
        { text: 'Pantorrilla', value: 'medidaPantorrilla' },
        { text: 'Espalda', value: 'medidaEspalda' },
      ],
      nuevaMedida: {
        peso: null,
        altura: null,
        medidaPecho: null,
        medidaCintura: null,
        medidaTriceps: null,
        medidaBiceps: null,
        medidaGluteos: null,
        medidaCuadriceps: null,
        medidaPantorrilla: null,
        medidaEspalda: null,
        fechaMedida: new Date().toISOString().substr(0, 10)
      },
      menuFecha: false,
      formValido: false,
      mensaje: {
        visible: false,
        texto: '',
        color: ''
      }
    }
  },
  filters: {
    fecha(val) {
      if (!val) return ''
      // Crear la fecha asegurando que se interprete como fecha local
      const fecha = new Date(val + 'T00:00:00')
      return fecha.toLocaleDateString('es-ES')
    }
  },
  mounted() {
    this.cargarHistorial()
  },
  methods: {
    cargarHistorial() {
      const payload = {
        metodo: 'obtenerHistorial',
        idMiembro: this.idMiembro
      }
      HttpService.obtenerConDatos(payload, 'medidas.php').then(res => {
        this.historial = res
      })
    },
    agregarMedida() {
      if (!this.nuevaMedida.peso || !this.nuevaMedida.altura || !this.nuevaMedida.fechaMedida) {
        this.mensaje = { visible: true, texto: 'Completa los campos obligatorios', color: 'error' }
        return
      }
      const datos = { ...this.nuevaMedida, idMiembro: this.idMiembro }
      const payload = {
        metodo: 'agregarMedidas',
        datos
      }
      HttpService.registrar(payload, 'medidas.php').then(res => {
        if (res.exito) {
          this.mensaje = { visible: true, texto: 'Medidas agregadas', color: 'success' }
          this.cargarHistorial()
        } else {
          this.mensaje = { visible: true, texto: 'Error al agregar', color: 'error' }
        }
      })
    }
  }
}
</script> 


// WEBPACK FOOTER //
// src/components/Miembros/HistorialMedidas.vue